// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { nextTuesday as fn } from "../nextTuesday.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const nextTuesdayWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default nextTuesdayWithOptions;
